<template>
  <modal title="View Terminal Details" width="35" :showModal="showModal" @close-modal="closeModal">
        
    <div v-if="loading" class="my-5">
      <loader />
    </div>

    <div class="location-details" v-else>

      <table>
        <tr>
          <td class="text-grey font-semibold">Terminal Name:</td>
          <td class="pl-2">{{ location.locationName }}</td>
        </tr>
        <tr>
          <td class="text-grey font-semibold">Address:</td>
          <td class="pl-2">{{ location.address }}</td>
        </tr>
        <tr>
          <td class="text-grey font-semibold">City:</td>
          <td class="pl-2">{{ location.city }}</td>
        </tr>
        <tr>
          <td class="text-grey font-semibold">State:</td>
          <td class="pl-2">{{ location.state }}</td>
        </tr>
        <tr>
          <td class="text-grey font-semibold">Country:</td>
          <td class="pl-2">{{ location.country }}</td>
        </tr>
        <tr>
          <td class="text-grey font-semibold">Zip/Postal Code:</td>
          <td class="pl-2">{{ location.zipCode }}</td>
        </tr>
      </table>

    </div>
    <div class="button-wrapper">
      <p class="font-semibold cursor-pointer" @click="closeModal">
        Close
      </p>
     
      <p class="text-primary-yellow font-semibold cursor-pointer" @click="isMapModal = true">
        View on Map
      </p>
    </div>
    <div v-if="!loading">
        <map-modal :address="location.address" :lat="parseFloat(location.lat)" :long="parseFloat(location.long)" :showModal="isMapModal"
          @close-modal="isMapModal = false" 
        />
    </div>
    
  </modal>
</template>

<script>
import MapModal from "./MapModal";
export default {
  components: {
    MapModal,
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    locationId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isMapModal: false,
      location: {},
      loading: true,
    };
  },
  mounted() {
    this.viewSingleLocation();
  },
  methods: {
    async viewSingleLocation() {
      try {
        let response = await this.$_getSingleLocationDetails(this.locationId);
        
        this.location = response.data.location;
        this.loading = false;
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    editLocation(locationId) {
      localStorage.setItem("locationId", locationId);
      this.$router.push({ name: "EditLocation" });
    },
    closeModal() {
      this.isMapModal = false;
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
td {
  padding: 0.25rem 0;
}
</style>
